(() => {
  const drawer = document.getElementById('QuickAddDrawer');
  const overlay = document.querySelector('[data-quick-add-close].quick-add-overlay');
  const closeButtons = document.querySelectorAll('[data-quick-add-close]');
  const form = document.querySelector('[data-quick-add-form]');
  const variantSelect = document.querySelector('[data-quick-add-variant]');
  const quantityInput = document.querySelector('[data-quick-add-quantity]');
  const titleEl = document.querySelector('[data-quick-add-title]');
  const priceEl = document.querySelector('[data-quick-add-price]');
  const imageEl = document.querySelector('[data-quick-add-image]');
  const messageEl = document.querySelector('[data-quick-add-message]');
  const submitButton = document.querySelector('[data-quick-add-submit]');
  const cartCountEl = document.querySelector('[data-cart-count]');
  const cartLink = document.querySelector('.site-cart');

  if (!drawer || !form || !variantSelect) return;

  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let currentProduct = null;
  let lastTrigger = null;

  const getFocusable = () => Array.from(drawer.querySelectorAll(focusableSelector))
    .filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);

  const moneyFromSelectedVariant = () => {
    const option = variantSelect.options[variantSelect.selectedIndex];
    if (!option) return '';
    return option.dataset.price || '';
  };

  const updatePrice = () => {
    const price = moneyFromSelectedVariant();
    if (price) priceEl.textContent = price;
  };

  const openDrawer = (trigger, product) => {
    currentProduct = product;
    lastTrigger = trigger;
    messageEl.textContent = '';
    form.reset();
    quantityInput.value = 1;

    titleEl.textContent = product.title || 'Produkt';
    priceEl.textContent = product.price || '';
    if (product.image) {
      imageEl.src = product.image;
      imageEl.alt = product.title || '';
      imageEl.closest('.quick-add-drawer__media').hidden = false;
    } else {
      imageEl.removeAttribute('src');
      imageEl.alt = '';
      imageEl.closest('.quick-add-drawer__media').hidden = true;
    }

    variantSelect.innerHTML = '';
    (product.variants || []).forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title === 'Default Title' ? 'Standard' : variant.title;
      option.disabled = !variant.available;
      option.dataset.price = variant.price || product.price || '';
      variantSelect.appendChild(option);
    });

    const firstAvailable = Array.from(variantSelect.options).find((option) => !option.disabled);
    if (firstAvailable) {
      variantSelect.value = firstAvailable.value;
      submitButton.disabled = false;
      submitButton.textContent = 'In meinen Warenkorb';
    } else {
      submitButton.disabled = true;
      submitButton.textContent = 'Ausverkauft';
      messageEl.textContent = 'Diese Variante ist aktuell nicht verfügbar.';
    }

    updatePrice();

    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('quick-add-open');
    if (overlay) overlay.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    setTimeout(() => variantSelect.focus(), 80);
  };

  const closeDrawer = () => {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.documentElement.classList.remove('quick-add-open');
    if (overlay) overlay.hidden = true;
    document.querySelectorAll('[data-quick-add-trigger][aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    if (lastTrigger) lastTrigger.focus();
  };

  const parseProduct = (trigger) => {
    const shell = trigger.closest('.product-card__media-shell');
    const script = shell ? shell.querySelector('[data-quick-add-product]') : null;
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Quick add product data is invalid.', error);
      return null;
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-add-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const product = parseProduct(trigger);
    if (product) openDrawer(trigger, product);
  });

  variantSelect.addEventListener('change', updatePrice);
  closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

  document.addEventListener('keydown', (event) => {
    if (drawer.getAttribute('aria-hidden') !== 'false') return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusable();
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!variantSelect.value) return;

    submitButton.disabled = true;
    submitButton.textContent = 'Wird hinzugefügt …';
    messageEl.textContent = '';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantSelect.value),
          quantity: Math.max(1, Number(quantityInput.value || 1))
        })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Das Produkt konnte nicht hinzugefügt werden.');
      }

      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((res) => res.json());
      if (cartCountEl && typeof cart.item_count !== 'undefined') {
        const count = Number(cart.item_count || 0);
        cartCountEl.textContent = count;
        cartCountEl.hidden = count < 1;
        cartCountEl.setAttribute('aria-label', count === 1 ? '1 Artikel im Warenkorb' : `${count} Artikel im Warenkorb`);
        if (cartLink) {
          cartLink.setAttribute('aria-label', count > 0 ? `Warenkorb öffnen, ${count} Artikel im Warenkorb` : 'Warenkorb öffnen');
        }
      }

      submitButton.textContent = 'Hinzugefügt';
      messageEl.textContent = 'Produkt wurde hinzugefügt.';
      setTimeout(() => {
        submitButton.disabled = false;
        submitButton.textContent = 'In meinen Warenkorb';
        closeDrawer();
        if (window.SkateCartDrawer && typeof window.SkateCartDrawer.refreshAndOpen === 'function') {
          window.SkateCartDrawer.refreshAndOpen();
        }
      }, 500);
    } catch (error) {
      messageEl.textContent = error.message || 'Das Produkt konnte nicht hinzugefügt werden.';
      submitButton.disabled = false;
      submitButton.textContent = 'In meinen Warenkorb';
    }
  });
})();
